export enum DocumentAssetTypeEnum {
  Order = 'Order',
  PurchaseOrder = 'PurchaseOrder',
  WorkOrder = 'WorkOrder',
  Project = 'Project',
  Task = 'Task',
  Logistic = 'Logistic',
}
